import { SkillDefinition, SkillUseContext } from "./types";
import { CombatEvent } from "../../state/combatEvents";

export const slashSkill = {
  id: "slash",
  name: "Slash",
  description: "Slash (3x dmg, self-hurt). At Lv3+, hits all enemies.",
  requiresTarget: true,
  use: ({
    targetIndex,
    skillLevel,
    applyDamageToEnemy,
    applyDamageToPlayerSelf,
    getPlayerAttack,
    hasValidTarget,
    getAliveEnemyIndices,
  }: SkillUseContext): CombatEvent[] => {
    // At level 3+, target all alive enemies; otherwise target only the selected enemy
    const isAoE = skillLevel >= 3;
    const targets = isAoE ? getAliveEnemyIndices() : [targetIndex];

    // Validate we have at least one valid target
    if (targets.length === 0 || (!isAoE && !hasValidTarget(targetIndex))) {
      return [];
    }

    const events: CombatEvent[] = [];
    const baseDamage = getPlayerAttack() * 3;

    for (const index of targets) {
      if (index === undefined) continue;
      const damage = applyDamageToEnemy(index, baseDamage);
      if (damage !== undefined) {
        events.push({
          kind: "playerAttack",
          targetIndex: index,
          amount: damage,
          ...(damage <= 0 ? { blocked: true } : {}),
        } as CombatEvent);
      }
    }

    const selfDamage = 2; // Fixed low cost instead of scaling with ATK
    const reflected = applyDamageToPlayerSelf(selfDamage);
    if (reflected) {
      events.push({ kind: "playerSelfDamage", amount: reflected } as CombatEvent);
    }

    return events;
  },
} satisfies SkillDefinition<"slash">;
